
















import AbstractAuthForm from '@/abstract/AuthForm'
import AuthLayout from '@/layout/AuthLayout.vue'
import { mapActions } from 'vuex'
import { AUTH__LOGIN } from '../../store/actions'

export default AbstractAuthForm.extend({
  components: {
    AuthLayout,
  },

  data: () => ({
    password: '',
  }),

  methods: {
    ...mapActions([AUTH__LOGIN]),

    enter(): void {
      this[AUTH__LOGIN](this.password).then(() => {
        this.$router.push('/scripts')
      })
    },
  },
  metaInfo() {
    return { title: this.$tc('auth.login') }
  },
})
